import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';

import { IMaterialIcons } from '@shared-interfaces/material-icons';

import { IMatCustomSvgIcons } from '../../../interfaces/custom-material-icons';
import { ITableConfigEntity } from '../../../interfaces/internal-interfaces';

@Component({
  selector: 'app-modal-content-default-change',
  templateUrl: './modal-content-default-change.component.html',
  standalone: false,
})
export class ModalContentDefaultChangeComponent {
  @Input() icon?: IMaterialIcons;
  @Input() svgIcon?: IMatCustomSvgIcons;
  @Input() body: string;
  @Input() title: string;
  @Input() values: IDefaultValueObject[];
  @Input() config: ITableConfigEntity[];

  @Output() public readonly default = new EventEmitter();

  @ViewChild('inputRef') inputRef: ElementRef;

  isButtonDisabled = true;

  handleValueChange() {
    this.isButtonDisabled = this.values.every((v) => v.currentBillcode === v.new);
  }

  handlePromptClicked() {
    this.default.emit(this.values);
  }
}

export interface IDefaultValueObject {
  label: string;
  activityFirstDigit?: string;
  current: string;
  currentBillcode: string;
  new: string;
}
